// 抖音授权页面
import { Helmet } from "react-helmet";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { authCallBack, getConfigParams, getShareUrlById } from "@/server";
import { Message } from "@arco-design/web-react";
import './index.less'

const timestamp = String(parseInt(String(Date.now() / 1000))); // 生成签名用的时间戳
const url = window.location.href

const NewHomePage: React.FC = () => {
    const [search] = useSearchParams()
    const dyId = search.get('id') || ''
    const dyUid = search.get('uid') || ''
    // 参数
    const [dyVisible, setDyVisible] = useState<boolean>(false) // 是否是抖音
    const [wxVisible, setWxVisible] = useState<boolean>(false) // 是否是微信
    const [sdk, setSdk] = useState<any>(null)  // 抖音sdk
    const [clientKey, setClientKey] = useState<string>(''); // 抖音clientKey
    const [ready, setReady] = useState<boolean>(false); // 抖音sdk是否ready

    // 方法
    const commEvent = {
        // 一键登录
        onLogin: async (e) => {
            if (ready) {
                sdk.showOpenAuth({
                    params: {
                        client_key: clientKey,
                        state: dyUid || "",
                        scopes: {
                            "user_info": 0, // 0: 必选；1: 可选，默认不选中； 2: 可选，默认选中
                            "video.data": 0,
                            "renew_refresh_token": 0,
                            "item.comment": 0,
                            "h5.share": 0
                        },
                        response_type: 'code'
                    },
                    success: (res) => {
                        const { ticket } = res;
                        commEvent.onTicket(ticket)
                    },
                    error: (error) => {
                        console.log('error ===>', error)
                    }
                })
            } else {
                Message.error('JSB 未就绪，请稍后重试');
            }
        },
        // 根据票据获取用户信息
        onTicket: async (_ticket: string) => {
            if (_ticket) {
                await authCallBack({ ticket: _ticket, state: dyUid || "" })
                if (!dyId) {
                    window.location.href = 'mengniumatrix://open'
                    return
                }
                const videoRes = await getShareUrlById(dyId)
                if (videoRes.code !== 0) {
                    Message.error(videoRes.message)
                    return
                }
                if (!videoRes?.data?.url) {
                    Message.error("暂未获取到地址")
                    return
                }
                const a = document.createElement("a");
                document.body.appendChild(a)
                a.href = videoRes.data.url
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a)
                }, 500);
            }
        },
        // 生成随机字符串的函数
        generateNonceStr: (length = 16) => {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        // 检查当前环境
        checkEnv: () => {
            const isDouyin = /aweme/i.test(navigator.userAgent);
            const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
            setDyVisible(isDouyin);
            setWxVisible(isWeixin);
            if (isWeixin) {
                Message.error('请在浏览器中打开链接！');
                return
            }
            if (!isDouyin) {
                const tryOpenDouyin = () => {
                    const currentUrl = encodeURIComponent(window.location.href);
                    const appScheme = `snssdk1128://webview/?url=${currentUrl}&type=webview&from=web`;
                    window.location.href = appScheme;
                }
                // 第一次尝试
                setTimeout(tryOpenDouyin, 2000);
                // 如果5秒后还在当前页面，再次尝试
                setTimeout(() => {
                    if (document.hidden === false) {
                        tryOpenDouyin();
                    }
                }, 5000);
            }
        }

    }
    // 获取配置，验证签名
    const config = useCallback(async () => {
        const nonce_str = commEvent.generateNonceStr(); // 生成签名用的随机字符串
        const { client_key, signature } = await getConfigParams({ timestamp, nonce_str, url })
        sdk.config({
            params: {
                client_key,
                signature,
                timestamp,
                nonce_str,
                url: url
            }
        })
        setClientKey(client_key);
    }, [sdk])

    // 监听sdk、config
    useEffect(() => {
        setSdk(window.douyin_open)
        if (sdk) {
            config()
            sdk.ready(() => { setReady(true) })
            sdk.error((error) => { console.log('sdk error ===>', error) })
        }
        commEvent.checkEnv()
    }, [sdk, config])

    return <div className="new-home-box">
        <Helmet><title>授权登录</title></Helmet>
        <div className="home_logo" />
        <div className="home_title" />
        <div className="home_desc">
            <div className="home-desc_text">
                哈喽～快来实现你的无限创意吧！
            </div>
        </div>
        <div className="home_foot">
            <div className="foot_btn" onClick={commEvent.onLogin}>一键授权登录</div>
            <div className="foot_auth">如您点击授权,您将同意并授权</div>
            <div className="foot_argeement">
                <span onClick={() => { window.open("/policy.html", "policy") }}>平台隐私政策</span>，
                <span onClick={() => { window.open("/agreement.html", "agreement") }}>平台用户服务协议</span>
            </div>
        </div>
        <div id="new-home-modal" className="home_modal" style={{ display: dyVisible ? 'none' : 'block' }}>
            <div className="home-modal_content">
                <h3>请在抖音App内继续操作</h3>
                {wxVisible ?
                    <p>检测到当前为微信环境，请在浏览器中打开链接</p>
                    : <p>检测到当前未使用抖音打开，请使用抖音打开链接</p>
                }
            </div>
        </div>
    </div>
}
export default NewHomePage